import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { PaginationParams } from '@/common/types';
import { API_URL, IContactInfoDto } from '@/dtos';

import {
  ClaimsProcessor,
  formatClaimsProcessorPayload,
} from './ClaimsProcessors.types';

// const ADMIN_3 = 6;
// const SUPER_USER = 3;

const formatData = (data: IContactInfoDto[]): ClaimsProcessor[] => data.map(formatClaimsProcessorPayload);

interface Props extends PaginationParams {
  enabled?: boolean;
  claimsTeamId?: string;
  assignedClaimsTeamIds?: string[];
}
const ALLOWED_PERMISSIONS = [15, 51, 44];
const useClaimsProcessorsListQuery = ({
  sortBy,
  page,
  perPage,
  searchString,
  claimsTeamId,
  enabled = true,
  assignedClaimsTeamIds,
}: Props) => {
  const { isLoading, data, refetch } = useQuery(
    [API_URL.CONTACTS_ALL, page, perPage, enabled, searchString, sortBy, claimsTeamId, assignedClaimsTeamIds],
    () =>
      api.get(`${API_URL.CONTACTS_ALL}${sortBy ? `?sort=firstName,${sortBy}&sort=lastName,${sortBy}` : ''}`, {
        params: {
          page,
          size: perPage,
          permission_ids: ALLOWED_PERMISSIONS.join(','),
          ...(searchString ? { search_value: searchString } : {}),
          ...(claimsTeamId ? { claims_team_id: claimsTeamId } : {}),
          assigned_claims_team_ids: assignedClaimsTeamIds?.join(','),
        },
      }),
    { enabled }
  );

  const total = useMemo<number>(() => data?.data?.totalElements || 0, [data]);
  const claimsProcessors = useMemo(() => {
    if (!data?.data?.content) return undefined;

    return formatData(data.data.content || []);
  }, [data]);

  return {
    claimsProcessors,
    total,
    isLoading,
    refetch,
  };
};

export default useClaimsProcessorsListQuery;
